import React, { Component } from 'react';
import { MODE_VERSION } from '../Config'

export class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render() {
    return (
      <div>
        <footer class="text-center" style={{ fontFamily: 'Nanum Gothic', fontSize: '12px' }}>
          <div class="container text-muted py-2">
            <ul class="list-inline mb-1">
              <li class="list-inline-item me-4"><a href="/cp_intro" target="_blank" style={{ color: 'inherit' }}>회사소개</a></li>
              <li class="list-inline-item me-4"><a target="_blank">상호명: 지쿠</a></li>
              <li class="list-inline-item me-4"><a target="_blank">사업자등록번호: 311-34-001638</a></li>
              <li class="list-inline-item"><a target="_blank">대표자: 조상훈</a></li>
            </ul>
            <ul class="list-inline mb-1">
              <li class="list-inline-item">
                <a target="_blank">
                  사업장: 대구광역시 남구 양지로 16, 조영호내과3층<br />
                  직업정보제공사업 신고번호: J1400020240003<br />
                  이메일: gkoosoft@gmail.com | 개인정보보호책임자: 조상훈<br />
                </a>
              </li>
            </ul>
            <p class="mb-0">Copyright © 2025 G-Worker {MODE_VERSION}</p>
          </div>
        </footer>
      </div>
    );
  }
}